<template>
    <div class="row" style="padding-top: 10px;">
        <div class="col-3">
            <button class="btn btn-success" @click="$emit('openAdd')">Add Product & Service</button>
        </div>
        <div class="col-9">
            <div class="row">
                <div class="col-2">
                    <!-- <div class="btn-group" ref="dropdown2">
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-light dropdown-toggle" @click="toggleDropdown2">
                                <i class="fas fa-columns"></i>
                            </button>
                            <ul class="dropdown-menu" :class="{ show: isOpen2 }">
                                <li v-for="(item, index) in fieldsList" :key="index">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input"
                                            :id="index + '-' + item.value" :checked="item.check"
                                            v-model="fieldsFilter" />
                                        <label class="custom-control-label" :for="index + '-' + item.value">
                                            {{ item.name }}
                                        </label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div> -->

                </div>
                <div class="col-4">
                    <!-- <div class="btn-group" ref="dropdown">
                        <button type="button" class="btn btn-light active">Row 200</button>
                        <button type="button" class="btn btn-light">Row 500</button>
                        <button type="button" class="btn btn-light">All Row</button>

                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-light dropdown-toggle" @click="toggleDropdown">
                                Pages
                            </button>
                            <ul class="dropdown-menu" :class="{ show: isOpen }">
                                <li><a class="dropdown-item" href="#" @click.prevent="selectOption('Acción 1')">Page
                                        1</a></li>
                                <li><a class="dropdown-item" href="#" @click.prevent="selectOption('Acción 2')">Page
                                        2</a></li>
                                <li><a class="dropdown-item" href="#" @click.prevent="selectOption('Acción 3')">Page
                                        3</a></li>
                            </ul>
                        </div>
                    </div> -->
                </div>
                <div class="col-6">
                    <input type="text" class="form-control" v-model="TextSearch" placeholder="Search Products"
                        @input="$emit('searchProduct', TextSearch)"
                        style="border: 1px solid #c9c9ca;float: right;margin-bottom: 10px;" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            TextSearch: null,
            isOpen: false,
            isOpen2: false,
            fieldsdropd: [],
            fieldsFilter: ["account", "name", "description", "unitCost", "cogs", "quantity", "taxes", "status"],
            fieldsList: [
                { value: "account", name: "Account", check: true },
                { value: "name", name: "Name", check: true },
                { value: "description", name: "Description", check: true },
                { value: "unitCost", name: "Unit Cost", check: true },
                { value: "cogs", name: "cogs", check: true },
                { value: "quantity", name: "Qty", check: true },
                { value: "taxes", name: "Taxes", check: true },
                { value: "status", name: "Status", check: true },
            ],
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        toggleDropdown2() {
            this.isOpen2 = !this.isOpen2;
        },
        selectOption(option) {
            console.log("Opción seleccionada:", option);
            this.isOpen = false; // cerrar el dropdown al seleccionar
        },
        handleClickOutside(event) {
          // si el click no fue dentro del dropdown -> cerrar
            if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                this.isOpen = false;
            }
            if (this.$refs.dropdown2 && !this.$refs.dropdown2.contains(event.target)) {
                this.isOpen2 = false;
            }
        },
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    }
};
</script>
<style scoped>
.btn-group .btn.btn-light {
    padding: 5px 10px;
}
.custom-control.custom-checkbox {
    padding-left: 35px;
    padding-top: 5px;
}
.custom-control.custom-checkbox:hover {
    background-color: #f3f3f3;
    cursor: pointer;
}
.custom-control.custom-checkbox:hover label.custom-control-label {
    cursor: pointer;
}
label.custom-control-label {
    font-size: 12px;
}

.custom-control-label::before {
    top: 0;
}

.custom-control-label::after {
    top: 0;
}
</style>
